import { t } from '@hefe/i18n';
import { currentUserSelector, updateUserSettings } from '@hefe/store';
import { Checkbox, Col, Descriptions, Row, Space, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { produce } from 'immer';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';

export default function UserSettingsSettingsComponent() {
  const dispatch = useAppDispatch();
  const [savingSettings, setSavingSettings] = useState(false);
  const user = useSelector(currentUserSelector);

  const updateShowKidsEvents = (event: CheckboxChangeEvent) => {
    const showEvents = event.target.checked;
    if (!user) {
      return;
    }

    const settings = produce(user.user_settings, (draft) => {
      draft.show_child_users = showEvents;
    });

    setSavingSettings(true);
    dispatch(updateUserSettings(settings))
      .unwrap()
      .finally(() => setSavingSettings(false));
  };

  const renderDescriptionLabel = (title: string, subtitle?: string) => {
    return (
      <Space direction="vertical" size={[0, 0]}>
        <Typography.Text strong>{title}</Typography.Text>
        {subtitle && (
          <Typography.Text style={{ fontSize: 12 }}>{subtitle}</Typography.Text>
        )}
      </Space>
    );
  };

  return (
    <Row justify="start">
      <Col xs={24} md={12}>
        <Descriptions bordered column={1}>
          <Descriptions.Item
            key={'childs'}
            label={renderDescriptionLabel(
              t('settings.user.child_events.title'),
              t('settings.user.child_events.description')
            )}
          >
            <Checkbox
              disabled={savingSettings}
              checked={user?.user_settings.show_child_users}
              onChange={(e) => updateShowKidsEvents(e)}
            />
          </Descriptions.Item>
        </Descriptions>
      </Col>
    </Row>
  );
}
